export const BRANCH_NAME = 'value';
export const VALUE = 'propertyValue';